/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_d6d52da6"]'><cube-slider :step="(5)" @change='(e)=>__invoke(e, [["handleChange"]])' @changing='(e)=>__invoke(e, [["handleChanging"]])'></cube-slider></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_d6d52da6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_d6d52da6"}
  /** script content **/
  require("./slider-step.mpx.js?isComponent&outputPath=components%2Fslider-stepd6d52da6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./slider-step.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fslider-stepd6d52da6%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_d6d52da6"],
    ctorType: "component",
    outputPath: "components/slider-stepd6d52da6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-slider':getComponent(require("../../../packages/mpx-cube-ui/src/components/slider/index.mpx?isComponent&outputPath=components%2Findex999434b0%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>